import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

var API = process.env.REACT_APP_API_URL || 'https://ivision-crm-backend-production.up.railway.app';

function PublicEstimate() {
  var { estimateNumber } = useParams();
  var [data, setData] = useState(null);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState(null);
  var [approving, setApproving] = useState(false);
  var [approved, setApproved] = useState(false);
  var [workOrder, setWorkOrder] = useState(null);

  useEffect(function() {
    fetch(API + '/api/public/estimate/' + estimateNumber)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.success) {
          setData(d);
          if (d.estimate.status === 'approved' || d.estimate.status === 'converted') setApproved(true);
        } else {
          setError('Estimate not found');
        }
        setLoading(false);
      })
      .catch(function() { setError('Could not load estimate'); setLoading(false); });
  }, [estimateNumber]);

  var handleApprove = function() {
    if (approving) return;
    setApproving(true);
    fetch(API + '/api/public/estimate/' + estimateNumber + '/approve', { method: 'POST' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.success) {
          setApproved(true);
          if (d.work_order) setWorkOrder(d.work_order);
        }
        setApproving(false);
      })
      .catch(function() { setApproving(false); });
  };

  if (loading) return (
    <div style={S.page}>
      <div style={S.card}><p style={{ color: '#888', textAlign: 'center', padding: '40px' }}>Loading estimate...</p></div>
    </div>
  );

  if (error) return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>📋</div>
          <p style={{ color: '#d63031', fontWeight: '700' }}>{error}</p>
          <p style={{ color: '#888', fontSize: '13px' }}>Check the link and try again.</p>
        </div>
      </div>
    </div>
  );

  var est = data.estimate;
  var biz = data.business || {};

  return (
    <div style={S.page}>
      {/* Business Header */}
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        {biz.logo_url && <img src={biz.logo_url} alt="" style={{ width: '60px', height: '60px', borderRadius: '14px', objectFit: 'cover', marginBottom: '8px' }} />}
        <h2 style={{ color: '#333', fontWeight: '800', fontSize: '20px', margin: 0 }}>{biz.business_name || 'Estimate'}</h2>
        {biz.address && <p style={{ color: '#999', fontSize: '12px', margin: '4px 0' }}>{biz.address}{biz.city ? ', ' + biz.city : ''}{biz.state ? ' ' + biz.state : ''}</p>}
        {biz.phone && <p style={{ color: '#999', fontSize: '12px', margin: 0 }}>{biz.phone}</p>}
      </div>

      {/* Main Card */}
      <div style={S.card}>
        {/* Estimate header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #f0f0f0' }}>
          <div>
            <div style={{ fontSize: '11px', color: '#999', fontWeight: '600', letterSpacing: '1px' }}>ESTIMATE</div>
            <div style={{ fontSize: '18px', fontWeight: '800', color: '#333' }}>{est.estimate_number}</div>
          </div>
          <div style={{ padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: '700',
            background: approved ? '#00b89420' : est.status === 'sent' ? '#0984e320' : '#f8f8fa',
            color: approved ? '#00b894' : est.status === 'sent' ? '#0984e3' : '#888',
          }}>
            {approved ? '✓ APPROVED' : (est.status || 'DRAFT').toUpperCase()}
          </div>
        </div>

        {/* Customer + Vehicle */}
        {est.customer && (
          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontSize: '15px', fontWeight: '700', color: '#333' }}>{est.customer.first_name} {est.customer.last_name}</div>
          </div>
        )}
        {est.vehicle && (
          <div style={{ background: '#f8f8fa', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>🏍️</span>
            <div>
              <div style={{ fontWeight: '700', color: '#333', fontSize: '14px' }}>
                {est.vehicle.year} {est.vehicle.make} {est.vehicle.model}
              </div>
              {est.vehicle.color && <span style={{ color: '#999', fontSize: '12px' }}>{est.vehicle.color}</span>}
              {est.vehicle.license_plate && <span style={{ color: '#999', fontSize: '12px', marginLeft: '8px' }}>{est.vehicle.license_plate}</span>}
            </div>
          </div>
        )}

        {/* Line Items */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', color: '#999', fontWeight: '600', letterSpacing: '1px', marginBottom: '10px' }}>ITEMS</div>
          {(est.items || []).map(function(item, idx) {
            return (
              <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid #f5f5f5' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontWeight: '600', color: '#333', fontSize: '14px' }}>{item.name}</span>
                    <span style={{ fontSize: '9px', fontWeight: '700', padding: '1px 6px', borderRadius: '4px',
                      background: item.type === 'parts' ? '#6c5ce720' : '#0984e320',
                      color: item.type === 'parts' ? '#6c5ce7' : '#0984e3',
                    }}>{(item.type || 'labor').toUpperCase()}</span>
                  </div>
                  {item.description && <div style={{ color: '#999', fontSize: '12px', marginTop: '2px' }}>{item.description}</div>}
                  {item.quantity > 1 && <div style={{ color: '#888', fontSize: '12px' }}>{item.quantity} × ${parseFloat(item.unit_price).toFixed(2)}</div>}
                </div>
                <div style={{ fontWeight: '700', color: '#333', fontSize: '14px', flexShrink: 0 }}>
                  ${parseFloat(item.total).toFixed(2)}
                </div>
              </div>
            );
          })}
        </div>

        {/* Totals */}
        <div style={{ background: '#f8f8fa', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span style={{ color: '#888', fontSize: '13px' }}>Subtotal</span>
            <span style={{ color: '#333', fontWeight: '600', fontSize: '13px' }}>${parseFloat(est.subtotal).toFixed(2)}</span>
          </div>
          {est.tax_amount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#888', fontSize: '13px' }}>Tax ({est.tax_rate}%)</span>
              <span style={{ color: '#333', fontWeight: '600', fontSize: '13px' }}>${parseFloat(est.tax_amount).toFixed(2)}</span>
            </div>
          )}
          {est.discount_amount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#888', fontSize: '13px' }}>Discount</span>
              <span style={{ color: '#00b894', fontWeight: '600', fontSize: '13px' }}>-${parseFloat(est.discount_amount).toFixed(2)}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px', borderTop: '2px solid #e8e8ee' }}>
            <span style={{ color: '#333', fontWeight: '800', fontSize: '16px' }}>Total</span>
            <span style={{ color: '#ff6b2b', fontWeight: '800', fontSize: '22px' }}>${parseFloat(est.total).toFixed(2)}</span>
          </div>
        </div>

        {/* Notes */}
        {est.notes && (
          <div style={{ background: '#fffbf5', border: '1px solid #ffe0c0', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', color: '#cc8833', fontWeight: '600', marginBottom: '4px' }}>NOTES</div>
            <div style={{ color: '#666', fontSize: '13px', whiteSpace: 'pre-wrap' }}>{est.notes}</div>
          </div>
        )}

        {/* Valid Until */}
        {est.valid_until && (
          <p style={{ color: '#999', fontSize: '12px', textAlign: 'center', marginBottom: '16px' }}>
            Valid until {new Date(est.valid_until).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        )}

        {/* Approve Button */}
        {!approved && est.status !== 'converted' && (
          <button onClick={handleApprove} disabled={approving}
            style={{
              width: '100%', padding: '16px', border: 'none', borderRadius: '14px', cursor: 'pointer',
              background: 'linear-gradient(135deg, #ff6b2b, #ffab40)', color: '#fff',
              fontWeight: '800', fontSize: '16px', opacity: approving ? 0.6 : 1,
              boxShadow: '0 4px 16px rgba(255,107,43,0.3)',
            }}>
            {approving ? 'Approving...' : '✓ Approve This Estimate'}
          </button>
        )}

        {/* Approved State */}
        {approved && (
          <div style={{ textAlign: 'center', padding: '16px' }}>
            <div style={{ fontSize: '48px', marginBottom: '8px' }}>✅</div>
            <h3 style={{ color: '#00b894', fontWeight: '800', marginBottom: '4px' }}>Estimate Approved!</h3>
            <p style={{ color: '#888', fontSize: '13px' }}>
              {workOrder
                ? 'Work order ' + workOrder.order_number + ' has been created. We\'ll get started right away!'
                : 'We\'ve been notified and will get started soon.'}
            </p>
          </div>
        )}
      </div>

      {/* Footer */}
      <p style={{ textAlign: 'center', color: '#ccc', fontSize: '11px', marginTop: '24px' }}>
        Powered by IVision Marketing
      </p>
    </div>
  );
}

var S = {
  page: { minHeight: '100vh', background: '#f5f5f8', padding: '24px 16px', maxWidth: '540px', margin: '0 auto' },
  card: { background: '#fff', borderRadius: '20px', padding: '28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: '16px' },
};

export default PublicEstimate;
